import React from 'react';

export const HomeIcon = props =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="15.969"
    viewBox="0 0 14 15.969"
    style={{
      fillRule: 'evenodd',
    }}
    {...props}
  >
    <path
      d="M366.969,379v8a1,1,0,0,1-1,1h-2.993a1,1,0,0,1-1-1v-3a2,2,0,1,0-3.991,0v3a1,1,0,0,1-1,1H354a1,1,0,0,1-1-1v-9h0v0s3.8-3.484,5.771-5.376a1.51,1.51,0,0,1,2.4-.021c2.071,1.786,5.809,5.4,5.809,5.4Z"
      transform="translate(-353 -372.031)"
    />
  </svg>;



// WEBPACK FOOTER //
// ./app/components/icons/home-icon.js